/**
 * @generated SignedSource<<f9a7764811e56b2667acfbd5d85ffa8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ManageProductMemberGroupsModalFragment$data = {
  readonly id: string;
  readonly member: {
    readonly fullName: string;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatarFragment">;
  };
  readonly memberGroupMemberships: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly memberGroup: {
          readonly id: string;
        };
      };
    }>;
  };
  readonly product: {
    readonly defaultMemberGroup: {
      readonly " $fragmentSpreads": FragmentRefs<"CreateMemberGroupButtonFragment">;
    };
    readonly " $fragmentSpreads": FragmentRefs<"MemberGroupsMultiSelect_ProductFragment">;
  };
  readonly " $fragmentType": "ManageProductMemberGroupsModalFragment";
};
export type ManageProductMemberGroupsModalFragment$key = {
  readonly " $data"?: ManageProductMemberGroupsModalFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ManageProductMemberGroupsModalFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ManageProductMemberGroupsModalFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "member",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProfileAvatarFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "groupKinds",
          "value": [
            "custom"
          ]
        }
      ],
      "concreteType": "MemberGroupMembershipNodeConnection",
      "kind": "LinkedField",
      "name": "memberGroupMemberships",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MemberGroupMembershipNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "MemberGroupMembership",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MemberGroup",
                  "kind": "LinkedField",
                  "name": "memberGroup",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "memberGroupMemberships(groupKinds:[\"custom\"])"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MemberGroup",
          "kind": "LinkedField",
          "name": "defaultMemberGroup",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CreateMemberGroupButtonFragment"
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MemberGroupsMultiSelect_ProductFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductMembership",
  "abstractKey": null
};
})();

(node as any).hash = "175ce511cee83905849a84b98dbf5b8a";

export default node;
